// Analytics utility for tracking user interactions
class Analytics {
  static isProduction = process.env.NODE_ENV === 'production';
  
  // Initialize analytics (call this when user logs in)
  static init(userId = null) {
    if (!this.isProduction || typeof window.gtag === 'undefined') return;
    
    if (userId) {
      window.gtag('config', 'G-EXVX3LMXC5', {
        user_id: userId
      });
    }
  }

  // Track page views
  static trackPageView(pageName, path = window.location.pathname) {
    if (!this.isProduction || typeof window.gtag === 'undefined') return;
    
    window.gtag('event', 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: path
    });
  }

  // Track user actions
  static trackEvent(action, category = 'engagement', label = null, value = null) {
    if (!this.isProduction || typeof window.gtag === 'undefined') return;
    
    const eventData = {
      event_category: category,
      event_label: label,
      value: value
    };
    
    window.gtag('event', action, eventData);
  }

  // Track social interactions
  static trackSocial(action, target) {
    this.trackEvent(action, 'social', target);
  }

  // Track user engagement
  static trackEngagement(action, details = null) {
    this.trackEvent(action, 'user_engagement', details);
  }

  // Track errors
  static trackError(errorMessage, errorLocation = 'unknown') {
    if (!this.isProduction || typeof window.gtag === 'undefined') return;
    
    window.gtag('event', 'exception', {
      description: errorMessage,
      fatal: false,
      custom_map: {
        location: errorLocation
      }
    });
  }

  // Track timing (for performance monitoring)
  static trackTiming(category, variable, value, label = null) {
    if (!this.isProduction || typeof window.gtag === 'undefined') return;
    
    window.gtag('event', 'timing_complete', {
      name: variable,
      value: value,
      event_category: category,
      event_label: label
    });
  }
}

export default Analytics; 